import { render, staticRenderFns } from "./RetailerTagBox.vue?vue&type=template&id=1bf716a2&lang=pug"
import script from "./RetailerTagBox.vue?vue&type=script&lang=js"
export * from "./RetailerTagBox.vue?vue&type=script&lang=js"
import style0 from "./RetailerTagBox.vue?vue&type=style&index=0&id=1bf716a2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports